import { createTheme } from "@mui/material";

const theme = createTheme({
    palette: {
      mode: 'light', // Change to 'dark' for dark mode
      primary: {
        main: "#20141e",
      },
      secondary: {
        main: '#6c757d',
      },
      background: {
        default: '#ffffff',
        paper: '#f5f5f5',
      },
      text: {
        primary: '#20141e',
        secondary: '#6c757d',
      },
    },
    colorSchemes: {
      dark: {
        palette: {
          primary: {
            main: "#20141e",
          },
          secondary: {
            main: '#6c757d',
          },
          background: {
            default: '#ffffff',
            paper: '#f5f5f5',
          },
          text: {
            primary: '#20141e',
            secondary: '#6c757d',
          },
        },
      },
    },
    components: {
      MuiButtonBase: {
        defaultProps: {
          disableRipple: true,
        },
      },
    },
  });

  export default theme;